import { forwardRef, type Ref, type SVGProps } from "react";
const IconPatioFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.7 7.3C23 .8 11.3.3 3.7 6L2.4 7.2A1 1 0 0 0 3 9h12v9h-5a1 1 0 0 0 0 2h5v9a1 1 0 0 0 2 0v-9h5a1 1 0 0 0 0-2h-5V9h12a1 1 0 0 0 1-.6 1 1 0 0 0-.3-1.1" />
    <path d="M10 22H4v-5a1 1 0 0 0-2 0v12a1 1 0 0 0 2 0v-5h5v5a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m19-6a1 1 0 0 0-1 1v5h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-5h5v5a1 1 0 0 0 2 0V17a1 1 0 0 0-1-1" />
  </svg>
);
const ForwardRef = forwardRef(IconPatioFilledSVG);
ForwardRef.displayName = "IconPatioFilled";
export { ForwardRef as IconPatioFilled };
